/** Whether an OpenCode event opens, answers, or cancels a question that waits on the user. */
export function isQuestionFormEvent(type: string): boolean {
  return type === 'form.created' || type === 'form.replied' || type === 'form.cancelled';
}
